import { render, staticRenderFns } from "./DefaultContainerListaVez.vue?vue&type=template&id=4675693c&"
import script from "./DefaultContainerListaVez.vue?vue&type=script&lang=js&"
export * from "./DefaultContainerListaVez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4675693c')) {
      api.createRecord('4675693c', component.options)
    } else {
      api.reload('4675693c', component.options)
    }
    module.hot.accept("./DefaultContainerListaVez.vue?vue&type=template&id=4675693c&", function () {
      api.rerender('4675693c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/DefaultContainerListaVez.vue"
export default component.exports